/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BsShopIntegrationData,
  BsShopIntegrationInput,
  ErrorResponse,
  GlamiIntegrationData,
  GlamiIntegrationInput,
  HeurekaIntegrationData,
  HeurekaIntegrationInput,
  ListProjectIntegrations200ResponseInner,
  MySQLLeadIntegrationData,
  MySQLLeadIntegrationInput,
  ShoptetIntegrationData,
  ShoptetIntegrationInput,
  SklikIntegrationData,
  SklikIntegrationInput,
  UpgatesIntegrationData,
  UpgatesIntegrationInput,
  ZboziIntegrationData,
  ZboziIntegrationInput,
} from '../models/index';
import {
    BsShopIntegrationDataFromJSON,
    BsShopIntegrationDataToJSON,
    BsShopIntegrationInputFromJSON,
    BsShopIntegrationInputToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GlamiIntegrationDataFromJSON,
    GlamiIntegrationDataToJSON,
    GlamiIntegrationInputFromJSON,
    GlamiIntegrationInputToJSON,
    HeurekaIntegrationDataFromJSON,
    HeurekaIntegrationDataToJSON,
    HeurekaIntegrationInputFromJSON,
    HeurekaIntegrationInputToJSON,
    ListProjectIntegrations200ResponseInnerFromJSON,
    ListProjectIntegrations200ResponseInnerToJSON,
    MySQLLeadIntegrationDataFromJSON,
    MySQLLeadIntegrationDataToJSON,
    MySQLLeadIntegrationInputFromJSON,
    MySQLLeadIntegrationInputToJSON,
    ShoptetIntegrationDataFromJSON,
    ShoptetIntegrationDataToJSON,
    ShoptetIntegrationInputFromJSON,
    ShoptetIntegrationInputToJSON,
    SklikIntegrationDataFromJSON,
    SklikIntegrationDataToJSON,
    SklikIntegrationInputFromJSON,
    SklikIntegrationInputToJSON,
    UpgatesIntegrationDataFromJSON,
    UpgatesIntegrationDataToJSON,
    UpgatesIntegrationInputFromJSON,
    UpgatesIntegrationInputToJSON,
    ZboziIntegrationDataFromJSON,
    ZboziIntegrationDataToJSON,
    ZboziIntegrationInputFromJSON,
    ZboziIntegrationInputToJSON,
} from '../models/index';

export interface AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface BSShopIntegrationRequest {
    projectId: string;
    integrationId?: string;
    bsShopIntegrationInput?: BsShopIntegrationInput;
}

export interface ChooseGoogleCustomerClientsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseMetaAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseMicrosoftAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface DeleteProjectIntegrationRequest {
    projectId: string;
    integrationId: string;
}

export interface GlamiIntegrationRequest {
    projectId: string;
    integrationId?: string;
    glamiIntegrationInput?: GlamiIntegrationInput;
}

export interface HeurekaIntegrationRequest {
    projectId: string;
    integrationId?: string;
    heurekaIntegrationInput?: HeurekaIntegrationInput;
}

export interface ListProjectIntegrationsRequest {
    projectId: string;
}

export interface MySQLLeadIntegrationRequest {
    projectId: string;
    integrationId?: string;
    mySQLLeadIntegrationInput?: MySQLLeadIntegrationInput;
}

export interface ShoptetIntegrationRequest {
    projectId: string;
    integrationId?: string;
    shoptetIntegrationInput?: ShoptetIntegrationInput;
}

export interface SklikIntegrationRequest {
    projectId: string;
    integrationId?: string;
    sklikIntegrationInput?: SklikIntegrationInput;
}

export interface UpgatesIntegrationRequest {
    projectId: string;
    integrationId?: string;
    upgatesIntegrationInput?: UpgatesIntegrationInput;
}

export interface ZboziIntegrationRequest {
    projectId: string;
    integrationId?: string;
    zboziIntegrationInput?: ZboziIntegrationInput;
}

/**
 * 
 */
export class ProjectIntegrationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/google`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the google platform authentication page.
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the google platform authentication page.
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the meta platform authentication page.
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the meta platform authentication page.
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/microsoft`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the microsoft platform authentication page.
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the microsoft platform authentication page.
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for bSShopIntegration without sending the request
     */
    async bSShopIntegrationRequestOpts(requestParameters: BSShopIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling bSShopIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/bs-shop`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BsShopIntegrationInputToJSON(requestParameters['bsShopIntegrationInput']),
        };
    }

    /**
     * Create or update BS Shop integration.
     */
    async bSShopIntegrationRaw(requestParameters: BSShopIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BsShopIntegrationData>> {
        const requestOptions = await this.bSShopIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BsShopIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update BS Shop integration.
     */
    async bSShopIntegration(requestParameters: BSShopIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BsShopIntegrationData> {
        const response = await this.bSShopIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseGoogleCustomerClients without sending the request
     */
    async chooseGoogleCustomerClientsRequestOpts(requestParameters: ChooseGoogleCustomerClientsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseGoogleCustomerClients().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseGoogleCustomerClients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/google/choose-customer-clients`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `customerClient` list to enable, others will be disabled.
     */
    async chooseGoogleCustomerClientsRaw(requestParameters: ChooseGoogleCustomerClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseGoogleCustomerClientsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `customerClient` list to enable, others will be disabled.
     */
    async chooseGoogleCustomerClients(requestParameters: ChooseGoogleCustomerClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseGoogleCustomerClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseMetaAdAccounts without sending the request
     */
    async chooseMetaAdAccountsRequestOpts(requestParameters: ChooseMetaAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseMetaAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseMetaAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/meta/choose-ad-accounts`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMetaAdAccountsRaw(requestParameters: ChooseMetaAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseMetaAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMetaAdAccounts(requestParameters: ChooseMetaAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseMetaAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseMicrosoftAdAccounts without sending the request
     */
    async chooseMicrosoftAdAccountsRequestOpts(requestParameters: ChooseMicrosoftAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseMicrosoftAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseMicrosoftAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/microsoft/choose-ad-accounts`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMicrosoftAdAccountsRaw(requestParameters: ChooseMicrosoftAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseMicrosoftAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMicrosoftAdAccounts(requestParameters: ChooseMicrosoftAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseMicrosoftAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectIntegration without sending the request
     */
    async deleteProjectIntegrationRequestOpts(requestParameters: DeleteProjectIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectIntegration().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling deleteProjectIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integration/{integrationId}`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes an integration from this platform.
     */
    async deleteProjectIntegrationRaw(requestParameters: DeleteProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes an integration from this platform.
     */
    async deleteProjectIntegration(requestParameters: DeleteProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for glamiIntegration without sending the request
     */
    async glamiIntegrationRequestOpts(requestParameters: GlamiIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling glamiIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/glami`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlamiIntegrationInputToJSON(requestParameters['glamiIntegrationInput']),
        };
    }

    /**
     * Create or update Glami integration.
     */
    async glamiIntegrationRaw(requestParameters: GlamiIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlamiIntegrationData>> {
        const requestOptions = await this.glamiIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlamiIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Glami integration.
     */
    async glamiIntegration(requestParameters: GlamiIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlamiIntegrationData> {
        const response = await this.glamiIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for heurekaIntegration without sending the request
     */
    async heurekaIntegrationRequestOpts(requestParameters: HeurekaIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling heurekaIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/heureka`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HeurekaIntegrationInputToJSON(requestParameters['heurekaIntegrationInput']),
        };
    }

    /**
     * Create or update Heureka integration.
     */
    async heurekaIntegrationRaw(requestParameters: HeurekaIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HeurekaIntegrationData>> {
        const requestOptions = await this.heurekaIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HeurekaIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Heureka integration.
     */
    async heurekaIntegration(requestParameters: HeurekaIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HeurekaIntegrationData> {
        const response = await this.heurekaIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectIntegrations without sending the request
     */
    async listProjectIntegrationsRequestOpts(requestParameters: ListProjectIntegrationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectIntegrations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of integration by project id.
     */
    async listProjectIntegrationsRaw(requestParameters: ListProjectIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListProjectIntegrations200ResponseInner>>> {
        const requestOptions = await this.listProjectIntegrationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListProjectIntegrations200ResponseInnerFromJSON));
    }

    /**
     * Returns list of integration by project id.
     */
    async listProjectIntegrations(requestParameters: ListProjectIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListProjectIntegrations200ResponseInner>> {
        const response = await this.listProjectIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mySQLLeadIntegration without sending the request
     */
    async mySQLLeadIntegrationRequestOpts(requestParameters: MySQLLeadIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling mySQLLeadIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/mysql-lead`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MySQLLeadIntegrationInputToJSON(requestParameters['mySQLLeadIntegrationInput']),
        };
    }

    /**
     * Create or update MySQL Lead integration.
     */
    async mySQLLeadIntegrationRaw(requestParameters: MySQLLeadIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MySQLLeadIntegrationData>> {
        const requestOptions = await this.mySQLLeadIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MySQLLeadIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update MySQL Lead integration.
     */
    async mySQLLeadIntegration(requestParameters: MySQLLeadIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MySQLLeadIntegrationData> {
        const response = await this.mySQLLeadIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shoptetIntegration without sending the request
     */
    async shoptetIntegrationRequestOpts(requestParameters: ShoptetIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shoptetIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/shoptet`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShoptetIntegrationInputToJSON(requestParameters['shoptetIntegrationInput']),
        };
    }

    /**
     * Create or update Shoptet integration.
     */
    async shoptetIntegrationRaw(requestParameters: ShoptetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShoptetIntegrationData>> {
        const requestOptions = await this.shoptetIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoptetIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Shoptet integration.
     */
    async shoptetIntegration(requestParameters: ShoptetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShoptetIntegrationData> {
        const response = await this.shoptetIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sklikIntegration without sending the request
     */
    async sklikIntegrationRequestOpts(requestParameters: SklikIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling sklikIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/sklik`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SklikIntegrationInputToJSON(requestParameters['sklikIntegrationInput']),
        };
    }

    /**
     * Create or update Sklik integration.
     */
    async sklikIntegrationRaw(requestParameters: SklikIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SklikIntegrationData>> {
        const requestOptions = await this.sklikIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SklikIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Sklik integration.
     */
    async sklikIntegration(requestParameters: SklikIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SklikIntegrationData> {
        const response = await this.sklikIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesIntegration without sending the request
     */
    async upgatesIntegrationRequestOpts(requestParameters: UpgatesIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling upgatesIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/upgates`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesIntegrationInputToJSON(requestParameters['upgatesIntegrationInput']),
        };
    }

    /**
     * Create or update Upgates integration.
     */
    async upgatesIntegrationRaw(requestParameters: UpgatesIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesIntegrationData>> {
        const requestOptions = await this.upgatesIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Upgates integration.
     */
    async upgatesIntegration(requestParameters: UpgatesIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesIntegrationData> {
        const response = await this.upgatesIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for zboziIntegration without sending the request
     */
    async zboziIntegrationRequestOpts(requestParameters: ZboziIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling zboziIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/zbozi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ZboziIntegrationInputToJSON(requestParameters['zboziIntegrationInput']),
        };
    }

    /**
     * Create or update Zbozi integration.
     */
    async zboziIntegrationRaw(requestParameters: ZboziIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZboziIntegrationData>> {
        const requestOptions = await this.zboziIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZboziIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Zbozi integration.
     */
    async zboziIntegration(requestParameters: ZboziIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZboziIntegrationData> {
        const response = await this.zboziIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
